import React, { Component } from "react";
import arrowleft from "./img/Arrows_Left.png";
import stipend from "./img/stipend.png";
import cur from "./img/cur.png";
import fee from "./img/fee.png";
import theory from "./img/theory.png";
import courses from "./img/cou.png";

//component
import KeyResponsibilities from "views/job-details/components/KeyResponsibilities";
import RelationshipBanner from "views/job-details/components/RelationshipBanner";
import IndiaStory from "views/job-details/components/IndiaStory";
import BusinessGroup from "views/job-details/components/BusinessGroup";
import JobVideoSlider from "views/job-details/components/JobVideoSlider";
import StoryView from "views/job-details/components/StoryView";
import EmployeeCard from "views/job-details/components/EmployeeCard";
import SimlarJobs from "views/job-details/components/SimlarJobs";
import MoreJobs from "views/job-details/components/MoreJobs";
import FooterSection from "views/home/components/FooterSection";
import Navbar from "components/Navbars/ApplicNavbar.js";
import "../css/Index.scss";
import { connect } from "react-redux";
import store from "store.js";
import Token from "api/Auth/auth";
import { setMgToken, setHcToken, setLoader } from "store/Auth";
import {
  getSingleJobAction,
  getRelatedJobs,
  getapplicationSummary,
  saveRegister,
} from "store/SingleJob";
import Footer from "./components/Skeleton";
import Modal from "react-responsive-modal";
let closeIcon = (
  <b style={{ fontSize: "30px", marginTop: "-20px", color: "black" }}>x</b>
);

class JobDetails extends Component {
  constructor(props) {
    super(props);
    this.childRef = React.createRef();
    this.state = {
      field: "",
      isFlushed: false,
      // jobDetails:''
      isAlreadyApplied: false,
      Contact: "",
      Email: "",
      Name: "",
      submitClicked: true,
      isOpenRejectModal: false,
    };
    this.onHandleSubmitChange = this.onHandleSubmitChange.bind(this);
  }

  applyFooter() {
    this.refs.child.footerApply();
  }
  checkJobAppliedorNot(JOBID) {
    //  debugger
    try {
      const element = this.props.ApplicationSummary.Data.JobsData.find(
        (value) => {
          return value.RID == JOBID;
        }
      );
      return typeof element === "undefined" ? false : true;
    } catch (error) {
      console.log(error);
    }
  }
  async onHandleSubmitChange(e) {
    e.preventDefault();
    // console.log("hello", this.state.Name);
    if (!this.state.Name) {
      alert("Name is required");
      return false;
    }
    if (!this.state.Email) {
      alert("Email is required");
      return false;
    }
    if (!this.state.Contact) {
      alert("Contact is required");
      return false;
    }
    let payload = {
      Name: this.state.Name,
      Email: this.state.Email,
      Contact: this.state.Contact,
      Job: "PGDFB",
    };
    let response = await this.props.SaveDetails(payload);
    // console.log("response", response);
    if (response.Code == 100) {
      // alert(response.Status);
      // window.open(
      //   "https://nucleus.niituniversity.in/register.aspx",
      //   "_blank"
      // )
      document.getElementById('registerurl').click()
      // window.location.reload();
      // e.preventDefault()
      this.setState({ submitClicked: true });
    }

    // console.log("payload", payload);
  }
  async componentDidMount() {
    try {
      this.props.setLoader(true);
      window.scrollTo(0, 0);
      // console.log(atob(atob(this.props.match.params.JID)), "KNOWWWUSSS PAGE");
      let JobID = atob(atob(this.props.match.params.JID));
      let HcToken = await Token.getToken();
      store.dispatch(setHcToken(HcToken));
      let MgToken = await Token.getTokenMagitt();
      store.dispatch(setMgToken(MgToken));

      let responsePreviewJob = await this.props.getSingleJobAction(JobID);
      this.props.setLoader(false);
      if (responsePreviewJob.Data.length <= 0) {
        this.props.history.push(process.env.PUBLIC_URL + "/Career/404-error");
      }

      if (this.props.Auth.HCID) {
        let ApplicationSummary = await this.props.getapplicationSummary(
          this.props.Auth.HCID
        );
        this.setState({ isAlreadyApplied: this.checkJobAppliedorNot(JobID) });
      }
    } catch (error) {}
  }
  render() {
    // let jobdec = ''
    console.log(this.state.Name);
    return (
      <div>
        <Navbar />
        <div className="mx-auto container pt-24">
          <RelationshipBanner
            isAlreadyApplied={this.state.isAlreadyApplied}
            ref={"child"}
          />
        </div>
        {/* <div className="lg:px-0 md:px-0 px-5">
          <div className="mx-auto container mb-12 lg:mt-12 md:mt-10 mt-8"> */}
           <div className="">
          <div className="lg:px-0 md:px-0 px-5 mx-auto container mb-12 lg:mt-12 md:mt-10 mt-8">

            {/* {this.props.previewjob && this.props.previewjob.Data ? ( */}
            <div
              className="content"
              // dangerouslySetInnerHTML={{
              //   __html: decodeURIComponent(jobdec),
              // }}
            ></div>
            {/* ) : ( */}
            {/* "" */}
            {/* )} */}
            {/* <label>
            Name:
            <input type="text" value={this.state.Name} onChange={(e) => this.setState({Name:e.target.value})} />        </label>
            <label>
            Email:
            <input type="text" value={this.state.Email} onChange={(e) => this.setState({Email:e.target.value})} />        </label>
            <label>
            Contact:
            <input type="text" value={this.state.Contact} onChange={(e) => this.setState({Contact:e.target.value})} />        </label>
            <input type="button" value="Submit" onClick={this.onHandleSubmitChange} /> */}
            <div>
              <p className="headtext pt-1">Programme details</p>
              <p className="cf-desc sm-text-justify">
              The Post Graduate Diploma in Banking & Finance with ICICI Bank,
                co-created by NIIT University (NU) and ICICI Bank, aims to
                create a cadre of specialised banking experts. The unique design
                of the programme focuses on providing a high degree of industry
                exposure by academic and functional experts from the financial
                domain and banking industry.

              </p>
              <p className="headtext pt-12">Course Features</p>
              <div className="grid md:grid-cols-3 lg:grid-cols-3 grid-cols-1 gap-6 w-full pt-4">
                <div className="cf-shadow p-6">
                  {/* https://ibb.co/pfRnKQN https://ibb.co/K2ML34L
                  https://ibb.co/C1TqWj9 https://ibb.co/qyQ93qh
                  https://ibb.co/qk6C5Sp */}{" "}
                  <img src={cur} className="h-12 mb-4" alt="feature" />
                  <p className="cf-ttl">Curriculum</p>
                  <p className="cf-desc1 pt-4">
                    The Programme will have blended curriculum entailing
                    classroom sessions, virtual learning & internship.
                  </p>
                </div>
                <div className="cf-shadow p-4">
                  {" "}
                  <img src={courses} className="h-12 mb-4" alt="feature" />
                  <p className="cf-ttl">Courses</p>
                  <p className="cf-desc1 pt-4">
                    The Programme will impart knowledge & skills in general
                    management, core banking, core finance and economics and
                    specialised courses in banking.
                  </p>
                </div>
                <div className="cf-shadow p-4">
                  {" "}
                  <img src={fee} className="h-12 mb-4" alt="feature" />
                  <p className="cf-ttl">Fee Details</p>
                  <p className="cf-desc1 pt-4">
                    INR 3,95,000 for the full year programme. The Fee includes
                    tuition & hostel fee which can be self funded or can be
                    funded using educational loan. Each student will be allotted
                    a single seater standard hostel room.
                  </p>
                </div>
              </div>
              <div className="pt-6 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-6 w-full">
                <div className="cf-shadow p-4">
                  {" "}
                  <img src={theory} className="h-12 mb-4" alt="feature" />
                  <p className="cf-ttl">Theory and practice</p>
                  <p className="cf-desc1 pt-4">
                    The Programme is designed with the view to providing the
                    {/* students with the optimum blend of theory and practice. 
                    <p className="cf-desc1"><strong className="cff">Term 1 & 2</strong> (6 months) – Classroom training (at NIIT University)</p>
                    
                    <strong className="cff">Term 3 & 4</strong> (6 months) – Internship at ICICI Bank */}
                    students with the optimum blend of theory and practice.
                    <p className="cf-desc1">
                      <strong className="cff">Term 1 & 2</strong> (6 months) –
                      Classroom training (at NIIT University)
                    </p>
                    <strong className="cff">Term 3 & 4</strong> (6 months) –
                    Internship at ICICI Bank

                  </p>
                </div>
                <div className="cf-shadow p-4">
                  {" "}
                  <img src={stipend} className="h-12 mb-4" alt="feature" />
                  <p className="cf-ttl">Training Stipend</p>
                  <p className="cf-desc1 pt-4">
                    The PGD students would be paid a monthly stipend during the
                    {/* training to meet their out of pocket expenses 
                    <p className="cf-desc1">Term 1 & 2 - <strong className="cff">Rs. 10,000/-</strong> per month </p>
                    Term 3 & 4 - <strong className="cff">Rs. 50,000/-</strong> per month</p> */}
                     training to meet their out of pocket expenses
                    <p className="cf-desc1">
                      Term 1 & 2 - <strong className="cff">Rs. 10,000/-</strong>{" "}
                      per month{" "}
                    </p>
                    Term 3 & 4 - <strong className="cff">Rs. 50,000/-</strong>{" "}
                    per month
                  </p>

                  
                </div>
              </div>
              <p className="mt-12 cf-note mb-8">
              {/* On successful completion of the Programme the students would get the opportunity to join as Manager at ICICI Bank with gross salary between INR 12 - 14 Lakhs per annum (CTC). */}
              On successful completion of the Programme the students would get
                the opportunity to join as Manager at ICICI Bank with gross
                salary between INR 12 - 14 Lakhs per annum (CTC).

              </p>
            </div>
            <p className="mb-2 headtext mt4imp">
            {/* If you are interested in applying please share your details and click on enroll now to fill your application form for the programme */}
            If you are interested in applying please share your details and
              click on enroll now to fill your application form for the
              programme

            </p>
            <form action="" className="w-full ">
              <div className="flex flex-wrap w-full">
                <div class="form-group modal-form-cs lg:w-1/3 md:w-1/3 w-full p-2">
                  {/* <label for=""> */}
                  <p className="headtext1 pb-2">
                    Name <span className="text-red">*</span>
                    </p>
                  {/* </label> */}
                  <input
                    type="text"
                    value={this.state.Name}
                    required="required"
                    placeholder="Enter your Name"
                    onChange={(e) =>
                      // this.setState({
                      //   resumeUpload: {
                      //     ...resumeUpload,
                      //     FirstName: e.target.value,
                      //   },
                      // })

                      this.setState({
                        Name: e.target.value
                          // .replace(/[^\w\s]/gi, "")
                          // .replace(/[^A-Za-z]/gi, ""),
                      })
                    }
                  />
                </div>
                <div class="form-group modal-form-cs lg:w-1/3 md:w-1/3 w-full p-2">
                  {/* <label for=""> */}
                  <p className="headtext1 pb-2">
                    Email ID <span className="text-red">*</span>
                    </p>
                  {/* </label> */}
                  <input
                    type="email"
                    value={this.state.Email}
                    required="required"
                    onChange={(e) =>
                      this.setState({
                        Email: e.target.value,
                        // .replace(/[^\w\s]/gi, "")
                        // .replace(/[^A-Za-z]/gi, ""),
                      })
                    }
                    placeholder="Enter your Email"
                  />
                </div>
                <a href="https://nucleus.niituniversity.in/register.aspx" id="registerurl" hidden></a>
                <div class="form-group lg:w-1/3 md:w-1/3 w-full p-2 modal-form-cs">
                  {/* <label for=""> */}
                  <p className="headtext1 pb-2">
                    Contact No <span className="text-red">*</span>
                    </p>
                  {/* </label> */}
                  <input
                    type="phone"
                    // disabled={true}
                    value={this.state.Contact}
                    required="required"
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        this.setState({
                          Contact: e.target.value.replace(/[^\d]/g, ""),
                        });
                      }
                    }}
                    placeholder="Enter Your Contact No."
                  />
                </div>
              </div>
              <div className="pt-6 text-center w-full">
                {/* <p className="mb-6 margint">
                  Please complete your registration here
                </p> */}
                <div>
                  {this.state.submitClicked ? (
                    <>
                    {/* <p className="mb-6 margint cf-desc2">
                      Please complete your registration here
                      </p> */}
                      {/* <br /> */}
                      {/* <button
                        type="button"
                        class="btn btn-filled btn-width-sm"
                        // disabled={this.getDate(DOB) ? "disabled" : ""} commented for resume check
                        onClick={() =>
                          window.open(
                            "https://nucleus.niituniversity.in/register.aspx",
                            "_blank"
                          )
                        }
                      >
                        Enroll Now
                      </button> */}
                      <button
                        type="button"
                        class="btn btn-filled btn-width-sm"
                        // disabled={this.getDate(DOB) ? "disabled" : ""} commented for resume check
                        onClick={this.onHandleSubmitChange}
                      >
                        Enroll Now
                      </button>
                    </>
                  ) : (
                    // <>
                    //   <button
                    //     type="button"
                    //     class="btn btn-filled btn-width-sm"
                    //     // disabled={this.getDate(DOB) ? "disabled" : ""} commented for resume check
                    //     onClick={this.onHandleSubmitChange}
                    //   >
                    //     Enroll Now1
                    //   </button>
                    // </> 
                    ""
                  )
                  }
                  {/* <button
                    type="button"
                      class="btn btn-filled btn-width-sm"
                      // disabled={this.getDate(DOB) ? "disabled" : ""} commented for resume check
                      onClick={ 
                         this.onHandleSubmitChange
                      }
                    >
                    Save
                    </button> */}
                </div>
              </div>
            </form>
          </div>
          <Footer />
          {/*
      <div className="mx-auto container my-16">
        <KeyResponsibilities />
      </div>
      <div className="bg-f8f8f8 ">
        <IndiaStory id={id}/>
      </div>

      <div className="mx-auto container my-16">
        <BusinessGroup id={id}/>
      </div>

      <div className="mx-auto container my-16">
        <JobVideoSlider />
      </div>

      <div className="bg-f8f8f8 ">
        <StoryView />
      </div>

      <div className="mx-auto container my-16">
        <EmployeeCard id={id}/>
      </div> */}
          {/* 
          <div className=" container mx-auto">
            <SimlarJobs />
            <div className="flex justify-center lg:mt-12 md:mt-12 mt-8">
              <button className="cust-viewall-btn flex">VIEW ALL</button>
            </div>
          </div>

          <div className=" container mx-auto pb-12 pt-4">
            <MoreJobs />
            <div className="flex justify-center lg:mt-12 md:mt-12 mt-8">
              <button className="cust-viewall-btn flex">VIEW ALL</button>
            </div>
          </div> */}
        </div>
        {/* <div className="fixed bottom-0 w-full footer-css-py-4">
          <FooterSection applyFooter={this.applyFooter.bind(this)} />
        </div> */}
      </div>
    );
  }
  // <Modal 
}
{/* <Modal
          open={this.state.isOpenRejectModal}
          classNames={{
            // overlay: "customOverlay",
            modal: "customModal",
          }}
          onClose={() => this.setState({ isOpenRejectModal: false })}
          center
          closeIcon={closeIcon}
  >

  </Modal> */}
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    previewjob: state.SingleJob.home.CURRENTJOB,
    ApplicationSummary: state.SingleJob.home.APPLICATIONSUMMARY,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SaveDetails: async (payload) => await dispatch(saveRegister(payload)),
    getSingleJobAction: async (payload) =>
      await dispatch(getSingleJobAction(payload)),
    getRelatedJobs: async (payload) => await dispatch(getRelatedJobs(payload)),
    getapplicationSummary: async (payload) =>
      await dispatch(getapplicationSummary(payload)),
    setLoader: async (flag) => await dispatch(setLoader(flag)),
  };
};

// const mapStateToProps = (state) => {
//   return {
//     Auth: state.Auth.user,
//     previewjob:state.SingleJob.home.CURRENTJOB
//   }
// }

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getSingleJobAction: async (payload) =>
//       await dispatch(getSingleJobAction(payload)),
//       getRelatedJobs: async (payload) =>
//       await dispatch(getRelatedJobs(payload)),

//   };
// };
// export default connect(mapStateToProps, mapDispatchToProps,null,{forwardRef:true})(Login);
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(JobDetails);
